var React = require('react');

function ArrowLeftShort (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22 11.9982H2.00181M2.00181 11.9982H2M2.00181 11.9982L2 12L9 19M2.00181 11.9982L9 5","stroke":"#142B6F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowLeftShort.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowLeftShort;

ArrowLeftShort.default = ArrowLeftShort;
